export enum PreviewDevice {
    Mobile = 'mobile',
    Desktop = 'desktop'
}

interface OwnProps {
    onClose?: () => void;
    slug?: string;
}

export type ComponentProps = OwnProps;
